export default "__VITE_ASSET__DKSTHrPR__"